import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.js';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary.js';
import './styles.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Entangled Vega could not find its application root.');
}

createRoot(rootElement).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>,
);
